// src/index.ts
import { CancelledError } from "./retryer.js";
import { QueryCache } from "./queryCache.js";
import { QueryClient } from "./queryClient.js";
import { QueryObserver } from "./queryObserver.js";
import { QueriesObserver } from "./queriesObserver.js";
import { InfiniteQueryObserver } from "./infiniteQueryObserver.js";
import { MutationCache } from "./mutationCache.js";
import { MutationObserver } from "./mutationObserver.js";
import { notifyManager, defaultScheduler } from "./notifyManager.js";
import { focusManager } from "./focusManager.js";
import { onlineManager } from "./onlineManager.js";
import {
  hashKey,
  partialMatchKey,
  replaceEqualDeep,
  isServer,
  matchQuery,
  matchMutation,
  keepPreviousData,
  skipToken,
  noop,
  shouldThrowError
} from "./utils.js";
import { isCancelledError } from "./retryer.js";
import {
  dehydrate,
  hydrate,
  defaultShouldDehydrateQuery,
  defaultShouldDehydrateMutation
} from "./hydration.js";
import { streamedQuery } from "./streamedQuery.js";
export * from "./types.js";
import { Query } from "./query.js";
import { Mutation } from "./mutation.js";
export {
  CancelledError,
  InfiniteQueryObserver,
  Mutation,
  MutationCache,
  MutationObserver,
  QueriesObserver,
  Query,
  QueryCache,
  QueryClient,
  QueryObserver,
  defaultScheduler,
  defaultShouldDehydrateMutation,
  defaultShouldDehydrateQuery,
  dehydrate,
  streamedQuery as experimental_streamedQuery,
  focusManager,
  hashKey,
  hydrate,
  isCancelledError,
  isServer,
  keepPreviousData,
  matchMutation,
  matchQuery,
  noop,
  notifyManager,
  onlineManager,
  partialMatchKey,
  replaceEqualDeep,
  shouldThrowError,
  skipToken
};
//# sourceMappingURL=index.js.map